import { IAppRoute } from 'interfaces/route';
import React from 'react';

import Entity from './Entity';

export default class EntityRouter extends React.PureComponent {
  // dynamically linked
  routes: IAppRoute[] = [
    {
      path: '/venture/:ventureId/entity/:entityId',
      sideDrawer: { display: 'Carregando...' },
      component: Entity,
      exact: false,
    },
  ];

  render() {
    return this.props.children;
  }
}
